import { MutationFunction, useMutation } from '@tanstack/react-query';
import { createAxiosInstance } from 'api/request';
import { MutationHook } from 'utils/hooks/mutations/types';

type RequestReturnType = void;
type RequestParameters = { type: 'unternehmen' | 'person'; id: string };

const request: MutationFunction<RequestReturnType, RequestParameters> = async ({ type, id }) =>
{
  await createAxiosInstance().post(`/gisa/${type}/${id}`);
};

const useCheckForGisaUpdatesMutation: MutationHook<RequestReturnType, RequestParameters> = (options) =>
{
  return useMutation({
    mutationFn: request,
    ...options,
  });
};

export default useCheckForGisaUpdatesMutation;